import {memo} from "react";
import {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleChevronUp} from "@fortawesome/free-solid-svg-icons";

export const PageTopBtn = memo(() => {
  const returnTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const pageTop = document.getElementById("pageTop");
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 200) {
        pageTop.classList.remove("fixed");
      } else {
        pageTop.classList.add("fixed");
      }
    });
  }, []);

  return (
    <div id="pageTop" className="fixed">
      <FontAwesomeIcon icon={faCircleChevronUp} onClick={returnTop} />
    </div>
  );
});
